import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { GoldButton, EASE } from "../shared";

export function LandingHero({ page, onCta }) {
  return (
    <section className="relative min-h-[78vh] flex items-end overflow-hidden bg-[#0A0A0A]" data-testid="landing-hero">
      <img src={page.image} alt={page.imageAlt} className="absolute inset-0 w-full h-full object-cover img-cinematic opacity-45" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-black/55 to-black/30" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 pt-40 pb-16 lg:pb-24 w-full">
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-[#71717A] mb-6" data-testid="landing-breadcrumb">
          <Link to="/" className="hover:text-[#F3E5AB] transition-colors">Home</Link>
          <ChevronRight size={11} />
          <span className="text-[#D4AF37]">{page.tag}</span>
        </nav>
        <motion.h1
          initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, ease: EASE }}
          className="font-serif-lux text-4xl sm:text-5xl lg:text-6xl leading-[1.05] text-[#F5F5F0] max-w-4xl"
          data-testid="landing-h1"
        >
          {page.h1[0]}<br /><span className="text-gold-gradient italic">{page.h1[1]}</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1, delay: 0.15, ease: EASE }}
          className="mt-6 text-sm sm:text-base text-[#A1A1AA] leading-relaxed max-w-2xl"
          data-testid="landing-intro"
        >
          {page.intro}
        </motion.p>
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.35 }} className="mt-8">
          <GoldButton onClick={onCta} data-testid="landing-hero-cta">{page.cta.title}</GoldButton>
        </motion.div>
      </div>
    </section>
  );
}
